"use client";
import Image from "next/image";
import { useRef, useState, useEffect } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { gtagEvent } from "../layout";
import { useSectionViewGtagEvent } from "./sectionViewEvent";

import "../stylesheets/main.scss";
import "../stylesheets/menuSelect.scss";
import cover_food from "../../../public/assets/img/menu_select_food.jpg";
import cover_feed from "../../../public/assets/img/menu_select_feed.jpg";
import cover_fuel from "../../../public/assets/img/menu_select_fuel.jpg";
import cloudsSVG from "../../../public/assets/svg/clouds_menu_select.svg";

export default function MenuSelect({ refreshPriority = 1 }) {
  const cloudsRef = useRef(null);
  const sectionRef = useRef(null);

  const [queryParams, setQueryParams] = useState("");

  useSectionViewGtagEvent(sectionRef, "MenuSelect", "top bottom");

  useEffect(() => {
    setQueryParams(window.location.search);
  }, []);

  const { contextSafe } = useGSAP();

  const btnEventNames = [
    "Feed_button_selected",
    "Fuel_button_selected",
    "Food_button_selected",
  ];

  const handleClick = contextSafe((e, path, btnEventName) => {
    e.preventDefault();

    if (btnEventNames.includes(btnEventName)) {
      gtagEvent(btnEventName, {
        event_category: "Navigation",
        label: btnEventName,
        destination: path,
      });
    }

    gsap.to(cloudsRef.current, {
      scale: 10,
      y: "-25vh",
      duration: 1,
      ease: "none",
      onComplete: () => {
        window.location.href = path + queryParams;
      },
    });
  });

  return (
    <div className="selection-menu" ref={sectionRef}>
      <div className="selection-content-wrapper">
        <div className="selection-content">
          <p className="p large larger-text">
            Learn how the checkoff is expanding the possibilities of soy.
          </p>
          <p className="p smaller-text">Pick a journey</p>
          <nav className="link-section">
            <a
              href="/feed"
              className="p link"
              onClick={(e) => handleClick(e, "/feed", btnEventNames[0])}
            >
              <div className="link-content">
                <Image
                  src={cover_feed}
                  alt=""
                  role="presentation"
                  className="card-image"
                />
                <div
                  className="text-wrapper"
                  style={{ backgroundColor: " #4FADF5" }}
                >
                  <p className="p smaller-text">Feed</p>
                </div>
              </div>
            </a>
            <a
              href="/fuel"
              className="p link"
              onClick={(e) => handleClick(e, "/fuel", btnEventNames[1])}
            >
              <div className="link-content">
                <Image
                  src={cover_fuel}
                  alt=""
                  role="presentation"
                  className="card-image"
                />
                <div
                  className="text-wrapper"
                  style={{ backgroundColor: " #7EB85B" }}
                >
                  <p className="p smaller-text">Fuel & Industrial</p>
                </div>
              </div>
            </a>
            <a
              href="/food"
              className="p link"
              onClick={(e) => handleClick(e, "/food", btnEventNames[2])}
            >
              <div className="link-content">
                <Image
                  src={cover_food}
                  alt=""
                  role="presentation"
                  className="card-image"
                />
                <div
                  className="text-wrapper"
                  style={{ backgroundColor: " #FFCD00" }}
                >
                  <p className="p smaller-text">Food</p>
                </div>
              </div>
            </a>
          </nav>
        </div>
        <Image
          ref={cloudsRef}
          src={cloudsSVG}
          alt=""
          role="presentation"
          className="menu-clouds"
        />
      </div>
    </div>
  );
}
